import { Star } from 'lucide-react';

interface TestimonialCardProps {
  name: string;
  business?: string;
  testimonial: string;
  rating: number;
  image?: string;
}

const TestimonialCard = ({
  name,
  business,
  testimonial,
  rating,
  image,
}: TestimonialCardProps) => {
  // Generate stars based on rating
  const stars = Array(5)
    .fill(0)
    .map((_, i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${i < rating ? 'text-tifpa-rose fill-current' : 'text-stone-300'}`}
      />
    ));

  return (
    <div className="bg-white rounded-lg shadow-md p-6 h-full flex flex-col">
      <div className="flex gap-2 mb-4">{stars}</div>
      <blockquote className="text-stone-600 mb-6 flex-grow">
        "{testimonial}"
      </blockquote>
      <div className="flex items-center gap-3">
        {image ? (
          <img
            src={image}
            alt={name}
            className="w-12 h-12 rounded-full object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-stone-200 flex items-center justify-center">
            <span className="text-stone-800 font-bold text-lg">
              {name.charAt(0)}
            </span>
          </div>
        )}
        <div>
          <h4 className="font-medium text-stone-800">{name}</h4>
          {business && <p className="text-sm text-stone-600">{business}</p>}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
